export const setMainAppInteractivity = (isInteractive: boolean) => {
  if (isInteractive) {
    document.getElementById('__next')?.removeAttribute('inert')
    document.getElementById('__next')?.removeAttribute('aria-hidden')
  } else {
    document.getElementById('__next')?.setAttribute('inert', 'true')
    document.getElementById('__next')?.setAttribute('aria-hidden', 'true')
  }
}
